import { Controller } from "stimulus";

export default class ListOfOpinions extends Controller {
	opinions_container: HTMLElement;
	clickLeft() {
		this.element.querySelector(
			".horizontal-scroller__element-container"
		).scrollLeft -= 300;
	}

	clickRight() {
		this.element.querySelector(
			".horizontal-scroller__element-container"
		).scrollLeft += 300;
	}

	connect() {
		this.opinions_container = this.element.querySelector(".opinions-container");
	}
}
